import {useEffect, Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {useLocation} from 'react-router-dom'
import {AccessibilityProvider} from './platform/accessibility'

const checkAppVersion = async () => {
  try {
    const response = await fetch('/version.json', {cache: 'no-store'})
    if (!response.ok) return

    const {version} = await response.json()

    // Versiyon değişmişse sayfayı yenile
    if (version !== window.appVersion) {
      localStorage.setItem('appVersion', version)
      // Tüm önbelleği temizle
      if ('caches' in window) {
        const cacheNames = await caches.keys()
        await Promise.all(cacheNames.map((cache) => caches.delete(cache)))
      }
      //window.location.reload();
      /*window.location.replace(
                    window.location.origin +
                    window.location.pathname +
                    window.location.search +
                    window.location.hash
                );*/
    }
  } catch (error) {
    console.error('Versiyon hata:', error)
  }
}

const App = () => {
  const location = useLocation()
  useEffect(() => {
    checkAppVersion()
  }, [location.pathname])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <AccessibilityProvider>
              <Outlet />
              <MasterInit />
            </AccessibilityProvider>
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
